// Download a backend export through fetch so the Authorization header is sent,
// then save the returned blob (an <a href> can't carry the bearer token).
export async function downloadExport(url: string, filename: string): Promise<void> {
  const token = localStorage.getItem('access_token')
  const res = await fetch(url, {
    headers: { Authorization: token ? `Bearer ${token}` : '' },
  })
  if (!res.ok) throw new Error(`export failed (${res.status})`)
  const blob = await res.blob()
  const href = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = href
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(href)
}
